import React from 'react'
import { CardMedia } from '@material-ui/core'
import { getRandomInt } from './util'
import imageClientHandler from './imageClientHandler'

function StoryItemBannerAd(props) {
  const { asset, adClick, api, width, height } = props
  const idx = getRandomInt(asset.ads.length)
  const { imageUrl, href='' } = asset.ads[idx]
  const src = imageClientHandler(imageUrl, api, width, height)

  let inner
  if(href.length > 0) {
    inner = (<a href={href} onClick={e => adClick(e, href)} >
              <img className="c-media--banner" src={ src } alt="" />
             </a>)
  } else {
    inner = <img className="c-media--banner" src={ src } alt="" />
  }

    return (
      <li style={{ listStyleType: 'none' }} >
      <CardMedia>
        { inner }
      </CardMedia>
    </li>
    )

}

export default StoryItemBannerAd
